var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fetching-error"},[_c('p',{staticClass:"text-danger"},[_vm._v(" "+_vm._s(_vm.userMessage)+" ")]),_vm._t("default"),_c('BButton',{attrs:{"variant":"lightest"},on:{"click":() => _vm.$emit('reload')}},[_vm._v(" "+_vm._s(_vm.$t('Neu laden'))+" ")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }